module.exports = __webpack_public_path__ + "static/img/7.d89be09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/1/7.png
// module id = 9e47
// module chunks = 1